/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-19 21:54:07 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-02-27 16:20:38
 */
 <template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" />
    <div class="docs">
      <h1>{{ st('helpDocs.promotionRequirements.h1') }}</h1>
      <h2>{{ st('helpDocs.promotionRequirements.h2Guide') }}</h2>
      <p>{{ st('helpDocs.promotionRequirements.pGuideIntro') }}</p>
      <ul>
        <li>{{ st('helpDocs.promotionRequirements.liG1') }}</li>
        <li>{{ st('helpDocs.promotionRequirements.liG2') }}</li>
        <li>{{ st('helpDocs.promotionRequirements.liG3') }}</li>
        <li>{{ st('helpDocs.promotionRequirements.liG4') }}</li>
        <li>{{ st('helpDocs.promotionRequirements.liG5') }}</li>
        <li>{{ st('helpDocs.promotionRequirements.liG6') }}</li>
      </ul>
      <h2>{{ st('helpDocs.promotionRequirements.h2Codes') }}</h2>
      <p>{{ st('helpDocs.promotionRequirements.pCodesQ') }}</p>
      <p>{{ st('helpDocs.promotionRequirements.pCodesA') }}</p>
      <ul>
        <li>{{ st('helpDocs.promotionRequirements.liC1') }}</li>
        <li>{{ st('helpDocs.promotionRequirements.liC2') }}</li>
      </ul>
    </div>
  </div>
</template>
<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
import { useSellerI18n } from '@/composables/useSellerI18n'

const { st } = useSellerI18n()
</script>
